import React from 'react'
import { Project } from '@pollination-solutions/pollination-sdk'

interface Props {
    project: Project
    setProject: (update: Project) => void
}

export default React.createContext<Props>({} as Props)
